module.exports = __webpack_public_path__ + "static/media/sort_icon.6898a04a.svg";